import { Link } from "react-router-dom";
import { STORE } from "@/constants/testIds";

const FOOTER_LINKS = [
  { to: "/about", label: "About" },
  { to: "/coverage", label: "Coverage" },
  { to: "/disclaimer", label: "Disclaimer", testId: STORE.footerDisclaimerLink },
  { to: "/refund", label: "Refund Policy", testId: STORE.footerRefundLink },
  { to: "/privacy", label: "Privacy Policy", testId: STORE.footerPrivacyLink },
  { to: "/terms", label: "Terms of Service", testId: STORE.footerTermsLink },
  { to: "/study/login", label: "Sign in / Start free" },
  { to: "/contact", label: "Contact", testId: STORE.footerContactLink },
];

const FooterBrand = () => (
  <div className="max-w-md">
    <div className="flex items-center gap-2.5">
      <img
        src="/brand/illinois-broker-prep-mark.svg"
        alt=""
        aria-hidden="true"
        className="h-9 w-9 shrink-0"
      />
      <span className="text-sm font-semibold tracking-wide text-white">
        Illinois Broker Prep
      </span>
    </div>
    <p
      data-testid={STORE.footerDisclaimer}
      className="mt-4 text-sm leading-6 text-white/70"
    >
      Illinois Broker Prep is an independent study aid operated by Coursewright.
      It is not affiliated with, endorsed by, or sponsored by IDFPR, PSI, the
      State of Illinois, or any testing authority. All practice questions are
      original and are not actual exam questions.
    </p>
  </div>
);

const FooterLinks = () => (
  <div className="md:text-right">
    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#E7BE4A]">
      Quick links
    </p>
    <div className="mt-4 flex flex-wrap gap-x-6 gap-y-3 text-sm md:justify-end">
      {FOOTER_LINKS.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          data-testid={l.testId}
          className="text-white/75 transition-colors hover:text-white"
        >
          {l.label}
        </Link>
      ))}
    </div>
  </div>
);

export const Footer = () => (
  <footer
    data-testid={STORE.footer}
    className="mt-auto border-t border-[color:rgba(231,190,74,0.14)] bg-[var(--ibp-navy-950)] text-white/75"
  >
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
        <FooterBrand />
        <FooterLinks />
      </div>
      <div className="mt-10 border-t border-white/10 pt-6 text-xs text-white/55">
        © 2026 Coursewright. All rights reserved. This tool is a study aid and
        does not constitute legal advice or a substitute for official licensing
        materials.
      </div>
    </div>
  </footer>
);

export default Footer;
